import { cache } from 'react';
import { CasinoCategory } from './types';

import { getIcon } from '@/Icons';
import { backendURL } from '@/backend/constants';

export const getCategories = cache(async () => {
	const apiUrl = `${backendURL}/casino/get-categories`;

	try {
		const response = await fetch(apiUrl, {
			headers: {
				'Content-Type': 'application/json',
			},
			next: { tags: ['game-categories'], revalidate: 60 },
			cache: 'force-cache',
		});

		const data = await response.json();

		const categories = data?.data?.casinoCategories as CasinoCategory[];

		if (categories) {
			const formattedCategories = categories.map((category) => {
				const iconKey = category?.name?.EN?.toLowerCase()
					.split('-')
					.join('')
					.replace(/ /g, '');
				const icon = getIcon(iconKey);

				return {
					...category,
					iconKey,
					icon,
				};
			});
			return formattedCategories;
		}
		return [];
	} catch (e: unknown) {
		const message = e instanceof Error ? e.message : 'Unknown error';

		return [];
	}
});
